module.exports = __webpack_public_path__ + "img/paperBox.b76f6405.png";